import { graphql } from "gql.tada";

import { agentChatFragment, deleteAgentChatPayloadFragment } from "./fragment";

export const CreateAgentChat = graphql(
  `mutation CreateAgentChat($input: CreateAgentChatInput!) {
    createAgentChat(input: $input) {
      ...AgentChat
    }
  }`,
  [agentChatFragment],
);

export const AppendAgentChatMessages = graphql(
  `mutation AppendAgentChatMessages($input: AppendAgentChatMessagesInput!) {
    appendAgentChatMessages(input: $input) {
      ...AgentChat
    }
  }`,
  [agentChatFragment],
);

export const UpdateAgentChatMessage = graphql(
  `mutation UpdateAgentChatMessage($input: UpdateAgentChatMessageInput!) {
    updateAgentChatMessage(input: $input) {
      ...AgentChat
    }
  }`,
  [agentChatFragment],
);

export const DeleteAgentChat = graphql(
  `mutation DeleteAgentChat($input: DeleteAgentChatInput!) {
    deleteAgentChat(input: $input) {
      ...DeleteAgentChatPayload
    }
  }`,
  [deleteAgentChatPayloadFragment],
);

export const UpdateAgentChat = graphql(
  `mutation UpdateAgentChat($input: UpdateAgentChatInput!) {
    updateAgentChat(input: $input) {
      ...AgentChat
    }
  }`,
  [agentChatFragment],
);
